import React, { useEffect, useState, useMemo } from 'react';
import './AINeuralEngine.css';

const AINeuralEngine = () => {
    const nodes = useMemo(() => {
        return Array.from({ length: 15 }).map((_, i) => ({
            id: i,
            x: 10 + Math.random() * 80,
            y: 10 + Math.random() * 80,
            size: 3 + Math.random() * 4
        }));
    }, []);

    const connections = useMemo(() => {
        const lines = [];
        for (let i = 0; i < nodes.length; i++) {
            // Connect each node to 2 nearest neighbors to create a network feel
            const neighbors = [...nodes]
                .filter(n => n.id !== nodes[i].id)
                .sort((a, b) => {
                    const distA = Math.hypot(a.x - nodes[i].x, a.y - nodes[i].y);
                    const distB = Math.hypot(b.x - nodes[i].x, b.y - nodes[i].y);
                    return distA - distB;
                })
                .slice(0, 2);

            neighbors.forEach(neighbor => {
                lines.push({
                    id: `${nodes[i].id}-${neighbor.id}`,
                    x1: nodes[i].x,
                    y1: nodes[i].y,
                    x2: neighbor.x,
                    y2: neighbor.y,
                    delay: Math.random() * 5
                });
            });
        }
        return lines;
    }, [nodes]);

    return (
        <div className="ai-neural-engine">
            <svg viewBox="0 0 100 100" preserveAspectRatio="none">
                {/* Synapses/Connections */}
                {connections.map(conn => (
                    <g key={conn.id}>
                        <line
                            x1={conn.x1} y1={conn.y1}
                            x2={conn.x2} y2={conn.y2}
                            className="synapse"
                        />
                        {/* Moving Data Pulse */}
                        <circle r="0.8" className="data-pulse" style={{ animationDelay: `${conn.delay}s` }}>
                            <animateMotion
                                dur="3s"
                                repeatCount="indefinite"
                                path={`M ${conn.x1} ${conn.y1} L ${conn.x2} ${conn.y2}`}
                            />
                        </circle>
                    </g>
                ))}

                {/* Neurons/Nodes */}
                {nodes.map(node => (
                    <circle
                        key={node.id}
                        cx={node.x}
                        cy={node.y}
                        r={node.size / 2}
                        className="neuron"
                    />
                ))}
            </svg>
        </div>
    );
};

export default AINeuralEngine;
